/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
// import router from './router';
import router from "./starterRouter";
import NowUiKit from './plugins/now-ui-kit';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'       // 配置后端请求访问
import vuetify from '@/plugins/vuetify' // path to vuetify export
import store from "@/store";
import { Upload, Table, TableColumn, Progress} from 'element-ui';

import VueMarkdownEditor from '@kangc/v-md-editor'; // 配置markdown编辑器
import '@kangc/v-md-editor/lib/style/base-editor.css'; // 导入markdown渲染样式
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'; // 导入markdown渲染样式
import githubTheme from '@kangc/v-md-editor/lib/theme/github'; // 导入markdown渲染样式 github
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn'; // 配置markdown编辑器 katex 公式语法
// import createCopyCodePlugin from '@kangc/v-md-editor/lib/plugins/copy-code/index'; // 配置markdown编辑器 copy code
import createEmojiPlugin from '@kangc/v-md-editor/lib/plugins/emoji/index'; // 配置markdown编辑器 emoji
// import createMermaidPlugin from '@kangc/v-md-editor/lib/plugins/mermaid/cdn'; // 配置markdown编辑器 流程图
import createTodoListPlugin from '@kangc/v-md-editor/lib/plugins/todo-list/index'; // 配置markdown编辑器 todo-list

Vue.config.productionTip = false;
Vue.prototype.$http = axios; // 更改后端请求函数名

Vue.use(NowUiKit);
Vue.use(Upload);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress);
VueMarkdownEditor.use(vuepressTheme); // 配置markdown编辑器样式
VueMarkdownEditor.use(githubTheme); // 配置markdown编辑器样式
VueMarkdownEditor.use(createKatexPlugin());
VueMarkdownEditor.use(createEmojiPlugin());
// VueMarkdownEditor.use(createMermaidPlugin());
VueMarkdownEditor.use(createTodoListPlugin());
// VueMarkdownEditor.use(createTipPlugin());
Vue.use(VueMarkdownEditor); // 配置markdown编辑器

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');
